var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_70a35574"]},_vm.$listeners),[_c('cube-button',{attrs:{"open-type":"openSetting","tip":"需在微信小程序环境预览"},on:{"openSetting":(e)=>_vm.__invoke(e, [["onOpenSetting"]])}},[_vm._v("打开授权设置页面")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }